
export const APP_STATUS_NOT_CONFIGURED = 'APP_STATUS_NOT_CONFIGURED';
export const APP_STATUS_READY = 'APP_STATUS_READY';
export const APP_STATUS_CONFIGURED = 'APP_STATUS_CONFIGURED';

export const APP_MODE_QA = 'APP_MODE_QA';
export const APP_MODE_DOCUMENTATION = 'APP_MODE_DOCUMENTATION';

export const CREDIT_CARD_PAYMENT_INSTRUMENT_TYPE = 'creditcard';



// WEBPACK FOOTER //
// ./src/app/AppConstants.js